import { Button } from '@nest/uikit-react';
import { ArchiveRestoreIcon, BoxesIcon, Trash2Icon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { TerminalScreen } from '../components/TerminalScreen';

export default function DeliveryPage() {
	const navigate = useNavigate();

	return (
		<TerminalScreen showBackButton backButtonTo="/" topBar={<div>Rozvozy</div>}>
			<div className="flex flex-col gap-2 p-2">
				<Button variant="outline" size="xl" onClick={() => navigate('/delivery/list')} className="w-full flex items-center justify-start gap-2">
					<BoxesIcon className="w-4 h-4" />
					Nakládání
				</Button>
				<Button variant="outline" size="xl" onClick={() => navigate('/delivery/returns/new')} className="w-full flex items-center justify-start gap-2">
					<ArchiveRestoreIcon className="w-4 h-4" />
					Vrácení zboží
				</Button>
				<Button variant="outline" size="xl" onClick={() => navigate('/delivery/returns/write-off')} className="w-full flex items-center justify-start gap-2">
					<Trash2Icon className="w-4 h-4" />
					Odpis vráceného zboží
				</Button>
			</div>
		</TerminalScreen>
	);
}
